/**
 * Обработка раскрывающихся списков с файлами
 */

const EXPANDED_LIST_ELEMENTS = {
    elementClass: '.js--expanded-list',
    btnElement: '.expanded-list__title',
    expandedClass: 'is-expanded'
};

export default function expandedList() {
    const allElementsOnPage = document.querySelectorAll(EXPANDED_LIST_ELEMENTS.elementClass);
    if (!allElementsOnPage) { return false; }

    allElementsOnPage.forEach((el) => {
        const elementBtn = el.querySelector(EXPANDED_LIST_ELEMENTS.btnElement);
        if (!elementBtn) { return false; }

        elementBtn.addEventListener('click', ({ target }) => {
            target.classList.toggle(EXPANDED_LIST_ELEMENTS.expandedClass);
        });
    });
}
